import { expenseColNm } from "constants/expenseConstant"
import { billingNoteColNm } from "constants/billingNoteConstant";
import { invoiceColNm } from "constants/invoiceConstant";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import dayjs from "dayjs";
import { numberFormat } from "utils";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Button } from "@mui/material";
export const columns= (handleSendDocDteClick) => [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center',
  },
  {
    field: 'CusSNm',
    headerName: billingNoteColNm.CusSNm,
    width: 250,
  },
  {
    field: 'BNDte',
    headerName: billingNoteColNm.BNDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'RecvPayDte',
    headerName: billingNoteColNm.RecvPayDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'BNNo',
    headerName: billingNoteColNm.BNNo,
    width: 150,
  },
  {
    field: 'NumInv',
    headerName: "จำนวนใบแจ้งหนี้",
    width: 110,
    align: "center"
  },
  {
    field: 'OwnRcptAmnt',
    headerName: billingNoteColNm.OwnRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: billingNoteColNm.CusRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'Total',
    headerName: billingNoteColNm.Total,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'SndDocDte',
    headerName: "วันที่ส่งเอกสาร",
    width: 120,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
    renderCell: (params) => {
      return (
        <Button fullWidth sx={{ height: 30 }} variant={params.value ? "contained" : "outlined"} onClick={()=>handleSendDocDteClick(params.row)}>
          {params.value&&dayjs(params.value).format("DD/MM/YYYY")}
        </Button>
      )
    },
  },
  {
    field: 'Rmk',
    headerName: billingNoteColNm.Rmk,
    flex: 1,
  }
]



export const invColumns = (handleDeleteRow)=>[
  
  {
    field: 'InvDte',
    headerName: invoiceColNm.InvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'InvNo',
    headerName: invoiceColNm.InvNo,
    width: 120,
  },
  {
    field: 'JobNos',
    headerName: invoiceColNm.JobNo,
    width: 150,
  },
  {
    field: 'OwnRcptAmnt',
    headerName: invoiceColNm.OwnRcptAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: invoiceColNm.CusRcptAmnt,
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'Total',
    headerName: invoiceColNm.Total,
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'OwnRcptAmntLit',
    headerName: invoiceColNm.OwnRcptAmnt + " (LIT)",
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'CusRcptAmntLit',
    headerName: invoiceColNm.CusRcptAmnt + " (LIT)",
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'TotalLit',
    headerName: invoiceColNm.Total + " (LIT)",
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'GrandTotal',
    headerName: "รวมยอด",
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'Rmk',
    headerName: expenseColNm.Rmk,
    flex: 1,
  },
  {
    hide: !handleDeleteRow,
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<RemoveCircleIcon />}
        label="Delete"
        onClick={() => handleDeleteRow(params.row)}
      />
    ] ,
  }
]

export const searchInvColumns = (selectInvoice)=>[
  {
    field: 'InvDte',
    headerName: invoiceColNm.InvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'InvNo',
    headerName: invoiceColNm.InvNo,
    width: 120,
  },
  {
    field: 'JobNos',
    headerName: invoiceColNm.JobNo,
    flex: 1,
  },
  {
    field: 'ShpmTypNms',
    headerName: "ประเภทงาน",
    width: 100,
  },
  {
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<ArrowForwardRoundedIcon />}
        label="เลือก"
        onClick={(e) =>{  
          e.stopPropagation()
          selectInvoice(params.row)}
        }
      />
    ] ,
  }
]
/**
 * 
 * Column Defination
 * {
 *   ...Datagrid Column
 *   printWidth: number
 *   printType: "number" | "string" //default string
 *   printAlign: "left" | "center" | "right" //default left
 *   printMaxLength: number //default 13/1 char/inch
 *   printNullChar: string //default "-"
 * }
 */

export const printBNColumns = [
  {
    field: "No",
    headerName: "No.",
    printWidth: 0.3,
    printAlign: "center",
    align: 'center',
  },
  {
    field: "ETD",
    headerName: "ETD",
    printWidth: 0.7,
    printAlign: "center",
    printType: "datetime",
    printFormat: "DD/MM/YYYY",
  },
  {
    field: "ETA",
    headerName: "ETA",
    printWidth: 0.7,
    printAlign: "center",
    printType: "datetime",
    printFormat: "DD/MM/YYYY",
  },
  {
    field: "CusInv",
    headerName: "Cus.Inv.No.",
    printWidth: 0.7,
    printAlign: "center",
    align: 'center',
  },
  {
    field: "CmdyTyp",
    headerName: "Goods",
    printWidth: 0.7,
  },
  {
    field: "Loc",
    headerName: "Loading Location",
    printWidth: 1.3,
    printMaxLength: 20,
  },
  {
    field: "Brnd",
    headerName: "Brand",
    printWidth: 0.7,
  },
  {
    field: "DrvNm",
    headerName: "Driver",
    printWidth: 0.9,
  },
  {
    field: "LicNm",
    headerName: "Truck",
    printWidth: 0.6,
  },
  {
    field: "Port",
    headerName: "Port",
    printWidth: 0.8,
    printMaxLength: 12,
  },
  {
    field: "ContNo",
    headerName: "Container No.",
    printWidth: 0.7,
  },
  {
    field: "GrandTotal",
    headerName: "Amnt",
    printType: "number",
    printAlign: "right",
    printWidth: 0.7,
  },
  {
    field: "WhtPr1Total",
    headerName: "WHT 1%",
    printType: "number",
    printAlign: "right",
    printWidth: 0.5,
  },
  {
    field: "WhtPr3Total",
    headerName: "WHT 3%",
    printType: "number",
    printAlign: "right",
    printWidth: 0.5,
  },
  {
    field: "PayAmnt",
    headerName: "Pay Amnt",
    printType: "number",
    printAlign: "right",
    printWidth: 0.7,
  },
]

export const printBankAccount = [
  {
    field: "Bank",
    headerName: "Bank",
    printWidth: 1.5
  },
  {
    field: "AccNo",
    headerName: "Account No.",
    printWidth: 1.5
  },
  {
    field: "AccNm",
    headerName: "Account Name",
    printWidth: 2
  },
  {
    field: "Amnt",
    headerName: "Pay Amnt",
    printWidth: 1.5,
    printType: "number",
    printAlign: "right",
  }
]